import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/frontend/src/components/marketing/Nav.tsx");
